import React from 'react'
import styled from 'styled-components'
import { Circle } from '@ui/icons/circle'
import { Devices } from '@styles'
import Play from './play.svg'
import Pause from './pause.svg'

interface TrackCardProps {
  trackId: React.ReactText
  coverUrl: string
  trackTitleUrl: string
  year: number
  artist: string
  title: string
  isPlayingNow: boolean
  playClicked: (id: React.ReactText) => void
  pauseClicked: (id: React.ReactText) => void
  trackCoverClicked: (id: React.ReactText) => void
}

export const TrackCard = (props: TrackCardProps) => (
  <TrackCardWrapper>
    <CoverWrapper>
      <Cover src={props.coverUrl} onClick={() => props.trackCoverClicked(props.trackId)} />

      <PlayerIconWrapper>
        <PlayerButton
          isPlaying={props.isPlayingNow}
          playClicked={() => props.playClicked(props.trackId)}
          pauseClicked={() => props.pauseClicked(props.trackId)}
        />
      </PlayerIconWrapper>
    </CoverWrapper>

    <Description>
      <CardHeader>
        <Year>{props.year}</Year>
        <CircleWrapper>
          <Circle color='pink' />
        </CircleWrapper>
        <Artist>{props.artist}</Artist>
      </CardHeader>

      <Title src={props.trackTitleUrl} alt='' />
    </Description>
  </TrackCardWrapper>
)

interface PlayerButtonProps extends React.HTMLAttributes<HTMLElement> {
  isPlaying: boolean
  playClicked: () => void
  pauseClicked: () => void
}

const PlayerButton = (props: PlayerButtonProps) =>
  props.isPlaying ? (
    <div style={{ display: 'flex' }} onClick={props.pauseClicked}>
      <Pause />
    </div>
  ) : (
    <div style={{ display: 'flex' }} onClick={props.playClicked}>
      <Play />
    </div>
  )

const TrackCardWrapper = styled.div`
  display: flex;
  flex-direction: column;

  width: 270px;
  margin-bottom: 20px;

  &:hover {
    > div:nth-child(2) {
      background: rgba(228, 105, 209, 0.2);
    }
  }

  @media screen and ${Devices.laptop} {
    margin-bottom: 120px;
  }
`

const CoverWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  position: relative;
`

const Cover = styled.img`
  cursor: pointer;

  height: 270px;
  max-width: 100%;
`

const Description = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 7px;

  background: rgba(228, 105, 209, 0.1);
  padding: 20px;

  min-height: 120px;

  @media screen and ${Devices.laptop} {
    height: 180px;
    min-height: unset;
  }
`

const Year = styled.span`
  font-size: 17px;
  line-height: 21px;

  position: relative;
  top: -1px;
`

const CircleWrapper = styled.div`
  display: flex;

  position: relative;
  top: 7px;
`

const Artist = styled.span`
  font-size: 17px;
  line-height: 19px;
`

const CardHeader = styled.div`
  display: flex;
  align-items: flex-start;
  column-gap: 5px;
`

const Title = styled.img`
  width: 80%;
  max-height: 90px;

  margin: auto;

  @media screen and ${Devices.laptop} {
    max-height: unset;
  }
`

const PlayerIconWrapper = styled.div`
  display: flex;

  position: absolute;
  bottom: 0;
  left: 0;

  cursor: pointer;
`
